import {EventEmitter} from '@angular/core';


export class FallbackEventEmitter<T> extends EventEmitter<T> {
    constructor(private fallback?: EventEmitter<T>) {
        super();
    }

    override emit(value?: T): void {
        if (!this.fallback || this.observed) {
            super.emit(value);
        } else {
            this.fallback?.emit(value);
        }
    }
}
